import { NotiConfigProvider } from './ConfigContext.tsx';
import { ConfigBody } from './components/ConfigBody/ConfigBody.tsx';

export const ConfigSection = () => (
  <NotiConfigProvider>
    <ConfigBody />
  </NotiConfigProvider>
);
